
import React from 'react';
import { ThumbsUp, ThumbsDown, Scale } from 'lucide-react';

interface CompanyMetricsProps {
  positiveExperiences: number;
  negativeExperiences: number;
  fairWorkCount: number;
}

const CompanyMetrics: React.FC<CompanyMetricsProps> = ({
  positiveExperiences,
  negativeExperiences,
  fairWorkCount
}) => {
  const totalExperiences = positiveExperiences + negativeExperiences;
  const positivePercentage = totalExperiences > 0 
    ? Math.round((positiveExperiences / totalExperiences) * 100) 
    : 0;
  
  return (
    <div className="flex flex-wrap gap-4 text-sm">
      <div className="flex items-center gap-1">
        <ThumbsUp className="h-4 w-4 text-green-600" />
        <span>{positivePercentage}% positive ({positiveExperiences})</span>
      </div>
      
      <div className="flex items-center gap-1">
        <ThumbsDown className="h-4 w-4 text-red-600" />
        <span>{100 - positivePercentage}% negative ({negativeExperiences})</span>
      </div>
      
      {fairWorkCount > 0 && (
        <div className="flex items-center gap-1">
          <Scale className="h-4 w-4 text-blue-600" />
          <span>{fairWorkCount} Fair Work cases</span>
        </div>
      )}
    </div>
  );
};

export default CompanyMetrics;
